import { render, staticRenderFns } from "./readList.vue?vue&type=template&id=7b0aded0&scoped=true"
import script from "./readList.vue?vue&type=script&lang=js"
export * from "./readList.vue?vue&type=script&lang=js"
import style0 from "./readList.vue?vue&type=style&index=0&id=7b0aded0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0aded0",
  null
  
)

export default component.exports